import { useState } from 'react';

const CorrectionRequestPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showCorrectionRequestPopup, setShowCorrectionRequestPopup] =
      useState<boolean>(false);

    const correctionRequestToggleHandler = () => {
      localStorage.setItem('images', JSON.stringify([]));
      setShowCorrectionRequestPopup(!showCorrectionRequestPopup);
    };

    return (
      <Component
        showCorrectionRequestPopup={showCorrectionRequestPopup}
        correctionRequestToggleHandler={correctionRequestToggleHandler}
        {...props}
      />
    );
  };

export default CorrectionRequestPopupHOC;
